import { Grid, MenuItem } from "@mui/material";
import React from "react";
import { Zone } from "src/interfaces/IZone";
import Select from "../../../UI/Select";
import { Sorter } from "../utils";

export default function ZoneSelector({
  selected,
  onSelect,
  options,
}: {
  selected?: number;
  onSelect: (selected?: number) => void;
  options: Zone[];
}) {
  return (
    <Grid container item sm={12} md={6}>
      <Select
        label="Zone"
        sx={{ flex: "1 1 100%" }}
        value={selected ?? ""}
        onChange={(zoneId) =>
          onSelect((zoneId !== "" ? zoneId : undefined) as number | undefined)
        }
      >
        <MenuItem value="">--</MenuItem>
        {[...options].sort(Sorter.zone).map((zone: Zone) => (
          <MenuItem key={zone.zone_id} value={zone.zone_id}>
            {zone.zone_name}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}
